const getName = (obj, langId) => {
  if (obj.attributeTemplate.names.length && langId) {
    let item = obj.attributeTemplate.names.find(n => n.id === langId);
    if (item) {
      return item.value;
    }
  }
  return `[ ${obj.attributeTemplate.code} ]`;
};

const getTableData = (list, defaultLangId) => {
  return list.map(item => {
    return {
      id: item.id,
      attributeId: item.attributeTemplate.id,
      name: getName(item, defaultLangId),
      attribute: item.attributeTemplate,
      numberInOrder: item.numberInOrder,
      required: item.required,
      used: item.used
    };
  });
};

const getUsedTypes = list => {
  return list.filter(item => item.used.length);
};

const attributeUsed = (objectTypeList, attributeId) => {
  return objectTypeList.some(item => item.attributeTemplate.id === attributeId);
};

const getAttributeName = (attributeItem, defaultLangId) => {
  let item = attributeItem.names.find(item => item.id === defaultLangId);
  if (item) {
    return item.value;
  }
  return "";
};

const getAttributes = (objectTypeList, attributeList, defaultLangId) => {
  if (objectTypeList && attributeList && defaultLangId) {
    return attributeList
      .filter(item => !attributeUsed(objectTypeList, item.id))
      .map(item => {
        return {
          attributeId: item.id,
          name: getAttributeName(item, defaultLangId),
          noTranslationRequired: item.noTranslationRequired,
          attribute: item.attributeType,
          numberInOrder:
            Math.max(...objectTypeList.map(ot => ot.numberInOrder), 0) + 1,
          required: false,
          used: []
        };
      });
  }
  return [];
};

const prepareToSave = (objectTypesId, attributs, id) => {
  return {
    objectTypesId,
    data: attributs
      .filter(attr => attr.attributeId === id)
      .map(attr => {
        return {
          attributeId: attr.attributeId,
          numberInOrder: attr.numberInOrder,
          required: attr.required,
          used: attr.used
        };
      })[0]
  };
};

const prepareToUpdate = (objectTypesId, items, id) => {
  return {
    id,
    objectTypesId,
    data: items
      .filter(item => item.id === id)
      .map(item => {
        return {
          attributeId: item.attributeId,
          numberInOrder: item.numberInOrder,
          required: item.required,
          used: item.used
        };
      })[0]
  };
};

export {
  getTableData,
  getUsedTypes,
  getAttributes,
  prepareToSave,
  prepareToUpdate
};
